import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

// ─── Popover variant ────────────────────────────────────────────────────────

export const PopoverContainer = styled.div`
  position: relative;
  display: inline-block;
  animation: ${fadeIn} 0.3s ease-in-out;
`

export const PopoverTrigger = styled.button`
  height: 34px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #dfe5f5;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #7e8286;
`

interface PopoverPanelProps {
  isOpen: boolean
}

export const PopoverPanel = styled.div<PopoverPanelProps>`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  padding: 10px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  z-index: 1000;
`

// ─── Inline variant ─────────────────────────────────────────────────────────

export const InlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  border: 1px solid var(--grey26);
  border-radius: 8px;
  padding: 1rem;
  gap: 16px;
`

export const InlineTrigger = styled.button`
  width: 100%;
  height: 18px;
  background: transparent;
  color: var(--grey15);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

// ─── Shared ─────────────────────────────────────────────────────────────────

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

interface OptionItemProps {
  isDisabled?: boolean
}

export const OptionItem = styled.div<OptionItemProps>`
  height: 34px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${props => (props.isDisabled ? 'default' : 'pointer')};
  color: ${props => (props.isDisabled ? '#49505766' : '#495057')};
  white-space: nowrap;
  font-size: 14px;
  line-height: 17px;
`

interface RadioDotProps {
  isSelected: boolean
}

export const RadioDot = styled.div<RadioDotProps>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 4px solid var(--grey26);
  background-color: ${props =>
    props.isSelected ? 'var(--blue)' : 'var(--grey26)'};
`
